import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import _ from 'lodash';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from '@angular/core';
import { DataService } from '../../services/data.service';
import { GraphUser } from '../../models/graph-user.model';

@Component({
  selector: 'app-real-estate-assignment-dialog',
  templateUrl: './real-estate-assignment-dialog.component.html',
  styleUrls: ['./real-estate-assignment-dialog.component.scss'],
  standalone: false,
})
export class RealEstateAssignmentDialogComponent implements OnInit {
  onYes = new EventEmitter();

  formOwner: GraphUser;
  formOwnerControl = new FormControl({ value: '', disabled: true });
  formOwnerOptions: GraphUser[];

  currentAssignment: GraphUser;
  currentAssignmentControl = new FormControl();
  currentAssignmentOptions: GraphUser[];

  constructor(
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RealEstateAssignmentDialogComponent>
  ) {}

  ngOnInit() {
    console.warn('RealEstateAssignmentDialogComponent :::: this.data :>> ', this.data);
    this.currentAssignment = this.data.currentAssignment;
    if (!(this.currentAssignment && this.currentAssignment.mail)) {
      this.currentAssignment = null;
    }
    this.formOwner = this.data.formOwner;
    if (!(this.formOwner && this.formOwner.mail)) {
      this.formOwner = null;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveAndClose() {
    let dataStructure = {
      currentAssignment: this.currentAssignment,
      formOwner: this.formOwner,
    };
    this.onYes.emit(dataStructure);
    this.dialogRef.close();
  }

  searchUsersFormOwner(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.formOwnerOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('formOwnerField')[0].focus();
      });
    });
  }

  deleteFormOwner() {
    this.formOwner = '' as any;
    this.formOwnerOptions = [];
  }

  displayFnFormOwner(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }

  searchUsersCurrentAssignment(searchText: any) {
    this.dataService.searchUsers(searchText).subscribe((result) => {
      this.currentAssignmentOptions = _.orderBy(result['value'], ['surname', 'givenName']);
      setTimeout(() => {
        document.getElementsByName('currentAssignmentField')[0].focus();
      });
    });
  }

  deleteCurrentAssignment() {
    this.currentAssignment = '' as any;
    this.currentAssignmentOptions = [];
  }

  displayFnCurrentAssignment(value: GraphUser): any | undefined {
    if (!value) {
      return '';
    } else if (value.givenName && value.surname && value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.givenName && value.surname && !value.jobTitle) {
      return value.givenName + ' ' + value.surname + ' (' + value.mail + ')';
    } else if (value.displayName && value.jobTitle) {
      return value.displayName + ' (' + value.mail + '), ' + value.jobTitle;
    } else if (value.displayName && !value.jobTitle) {
      return value.displayName + ' (' + value.mail + ')';
    } else {
      return value;
    }
  }
}
